/**
 * Report and notification contracts (design §5.7). A report is always a job: the request
 * returns `202` with an id, and the client follows its status until it can be downloaded.
 */
import { z } from 'zod';
import { HOURS_FORMATS, REPORT_STATUSES, REPORT_TYPES } from '../enums.js';
import { instantSchema, paginated, paginationQuerySchema, uuidSchema } from './common.js';
import { reportFiltersSchema } from './time.js';
export const reportOptionsSchema = z.object({
    hoursFormat: z.enum(HOURS_FORMATS).optional(),
    /** Charts are drawn into the PDF; the spreadsheets ignore this. */
    includeCharts: z.boolean().default(true),
});
export const createReportSchema = z.object({
    title: z.string().trim().max(200).optional(),
    filters: reportFiltersSchema,
    options: reportOptionsSchema.default({ includeCharts: true }),
});
/** The entries export takes the same filters; there is nothing to configure beyond them. */
export const createExportSchema = z.object({
    title: z.string().trim().max(200).optional(),
    filters: reportFiltersSchema,
});
export const reportSchema = z.object({
    id: uuidSchema,
    type: z.enum(REPORT_TYPES),
    status: z.enum(REPORT_STATUSES),
    title: z.string(),
    filters: z.record(z.string(), z.unknown()),
    options: z.record(z.string(), z.unknown()),
    requestedBy: z.object({ id: uuidSchema, name: z.string() }).nullable(),
    fileSizeBytes: z.number().int().nullable(),
    rowCount: z.number().int().nullable(),
    errorMessage: z.string().nullable(),
    startedAt: instantSchema.nullable(),
    completedAt: instantSchema.nullable(),
    expiresAt: instantSchema.nullable(),
    createdAt: instantSchema,
});
export const listReportsQuerySchema = paginationQuerySchema.extend({
    type: z.enum(REPORT_TYPES).optional(),
    status: z.enum(REPORT_STATUSES).optional(),
});
export const reportListSchema = paginated(reportSchema);
export const reportAcceptedSchema = z.object({ reportId: uuidSchema });
// --------------------------------------------------------------- notifications
export const notificationSchema = z.object({
    id: uuidSchema,
    type: z.string(),
    payload: z.record(z.string(), z.unknown()),
    readAt: instantSchema.nullable(),
    createdAt: instantSchema,
});
export const notificationListSchema = z.object({
    data: z.array(notificationSchema),
    unread: z.number().int().nonnegative(),
});
//# sourceMappingURL=reports.js.map